export default __webpack_public_path__ + "images/icons/bag-2b6c2a149706c3044108b5448f91887e.svg";